import "./SnapWidgetPrivacyPolicy.css";

const updatedAt = "May 17, 2026";

const sections = [
  {
    title: "1. Our Services",
    body: [
      "SnapWidget is a private photo widget that helps you stay connected with the people who matter most without public feeds, noise, or pressure.",
      "The Services are not intended for use in jurisdictions where their use would violate local law or require us to register in that jurisdiction. You are responsible for complying with local laws when you use the Services."
    ]
  },
  {
    title: "2. Intellectual Property Rights",
    body: [
      "BlackDoor owns or licenses the software, designs, code, databases, text, photos, graphics, trademarks, service marks, and other materials used in the Services.",
      "Subject to these Terms, we grant you a limited, revocable, non-exclusive, non-transferable license to access and use SnapWidget for personal, non-commercial purposes.",
      "You may not copy, reproduce, distribute, sell, license, modify, reverse engineer, or exploit any part of the Services except as expressly allowed by these Terms or by law."
    ]
  },
  {
    title: "3. User Representations",
    body: [
      "By using SnapWidget, you represent that your registration information is true, current, and complete, that you have legal capacity to agree to these Terms, and that your use will comply with applicable law.",
      "You also agree not to access the Services through bots, scripts, or other automated or non-human means."
    ]
  },
  {
    title: "4. User Registration",
    body: [
      "You may be required to create an account to use the Services. You are responsible for maintaining the confidentiality of your account and password.",
      "We may remove, reclaim, or change a username if we determine that it is inappropriate, obscene, misleading, or otherwise objectionable."
    ]
  },
  {
    title: "5. Products",
    body: [
      "Products, paid features, and subscription options are subject to availability. We may change, suspend, or discontinue any product or feature at any time.",
      "Prices may change, and we reserve the right to correct pricing errors even after a purchase request has been submitted."
    ]
  },
  {
    title: "6. Purchases and Payment",
    body: [
      "You agree to provide current, complete, and accurate purchase and account information for purchases made through the Services.",
      "You authorize the applicable payment provider to charge your selected payment method for purchases, subscriptions, taxes, and other charges shown at checkout.",
      "Payments may be processed through app store or payment partners, including Google Play, and are also subject to those providers' terms."
    ]
  },
  {
    title: "7. Subscriptions",
    body: [
      "Subscriptions automatically renew unless canceled. You consent to recurring charges until you cancel the applicable subscription.",
      "The billing cycle depends on the subscription plan you choose. You can cancel through your account, app store account, or the payment provider where the purchase was made.",
      "We may offer a 30-day free trial to new users. Unless otherwise stated, the account will not be charged and the subscription will be suspended until upgraded to a paid version."
    ]
  },
  {
    title: "8. Refunds",
    body: [
      "All sales are final except where required by law or by the applicable app store or payment provider policy.",
      "Refunds may be claimed only within 24 hours from payment. Refund requests made after that period may be deemed invalid."
    ]
  },
  {
    title: "9. Prohibited Activities",
    body: [
      "You may not use the Services for unlawful, unauthorized, harmful, abusive, fraudulent, automated, or commercial purposes not approved by us.",
      "You may not interfere with security features, impersonate others, collect user data without permission, upload malicious code, reverse engineer the Services, harass users or staff, or use SnapWidget to compete with us.",
      "You may not sell or transfer your profile or use the Services to advertise or offer goods and services unless we expressly approve it."
    ]
  },
  {
    title: "10. User Generated Contributions",
    body: [
      "The Services may allow you to create, submit, upload, post, or share photos, text, comments, profile information, or other content.",
      "You are responsible for your contributions and must have all rights and permissions needed to share them. Your contributions must not be illegal, abusive, misleading, obscene, infringing, invasive of privacy, or harmful to minors.",
      "We may remove, edit, restrict, or disable content at our discretion if we believe it violates these Terms or may harm users, the Services, or BlackDoor."
    ]
  },
  {
    title: "11. Contribution License",
    body: [
      "You keep ownership of your contributions. By posting or sharing contributions through the Services, you grant BlackDoor a worldwide, royalty-free, transferable license to host, store, display, reproduce, modify, and distribute them as needed to operate, improve, protect, and promote the Services.",
      "You waive moral rights to the extent permitted by law and confirm that your contributions do not contain confidential information unless we have separately agreed otherwise."
    ]
  },
  {
    title: "12. Mobile Application License",
    body: [
      "If you access the Services through the SnapWidget app, we grant you a limited, revocable, non-transferable license to install and use the app on devices you own or control.",
      "You may not decompile, reverse engineer, modify, create derivative works from, remove proprietary notices from, or use the app to build a competing product.",
      "If you obtained the app through Apple App Store or Google Play, the applicable app distributor's terms also apply."
    ]
  },
  {
    title: "13. Social Media and Third-Party Accounts",
    body: [
      "If SnapWidget allows account linking with third-party services, you represent that you have the right to provide those credentials or permissions.",
      "Your relationship with third-party providers is governed by your agreements with them. We are not responsible for third-party services or content."
    ]
  },
  {
    title: "14. Services Management",
    body: [
      "We may monitor the Services for violations, restrict or disable content, remove burdensome files, suspend accounts, and take legal action where appropriate.",
      "We may manage the Services in any manner designed to protect users, our rights, our property, and the proper functioning of SnapWidget."
    ]
  },
  {
    title: "15. Privacy Policy",
    body: [
      "Your use of the Services is also governed by our Privacy Policy, which is incorporated into these Terms.",
      "The Services are hosted in India. If you access the Services from another region, you consent to transfer and processing of your information in India."
    ],
    link: {
      label: "Review the SnapWidget Privacy Policy",
      href: "/apps/snapwidget/privacy-policy"
    }
  },
  {
    title: "16. Copyright Infringements",
    body: [
      "We respect intellectual property rights. If you believe material available through the Services infringes your copyright, contact us with enough detail for us to review the claim.",
      "You may be liable for damages if you knowingly make a material misrepresentation in a copyright notice."
    ]
  },
  {
    title: "17. Term and Termination",
    body: [
      "These Terms remain in effect while you use the Services. We may deny access, suspend, terminate, or delete your account or content at any time if we believe you violated these Terms or applicable law.",
      "If your account is suspended or terminated, you may not create another account under your name, a false name, or another person's name without our permission."
    ]
  },
  {
    title: "18. Modifications and Interruptions",
    body: [
      "We may change, suspend, discontinue, or remove features or content at any time. We are not liable for modification, price changes, suspension, downtime, or discontinuance of the Services.",
      "We do not guarantee that the Services will always be available, uninterrupted, secure, or error-free."
    ]
  },
  {
    title: "19. Governing Law",
    body: [
      "These Terms are governed by the laws of India. BlackDoor and you consent to the jurisdiction of the courts of India for disputes that may arise in connection with these Terms, subject to the dispute resolution provisions below."
    ]
  },
  {
    title: "20. Dispute Resolution",
    body: [
      "Before starting arbitration or court proceedings, the parties agree to attempt informal negotiations for at least sixty (60) days after written notice of a dispute.",
      "Any dispute arising out of or in connection with these Terms will be referred to and finally resolved by arbitration under the rules of the International Commercial Arbitration Court under the European Arbitration Chamber. The number of arbitrators will be two (2), the seat of arbitration will be Bangalore, India, and the language will be English.",
      "Arbitration will be limited to the dispute between the parties individually. Class actions and representative proceedings are not permitted to the fullest extent allowed by law."
    ]
  },
  {
    title: "21. Corrections",
    body: [
      "The Services may contain typographical errors, inaccuracies, or omissions. We may correct or update information at any time without prior notice."
    ]
  },
  {
    title: "22. Disclaimer",
    body: [
      "THE SERVICES ARE PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.",
      "We do not warrant that the Services, content, linked services, or third-party offerings will be accurate, complete, secure, uninterrupted, or error-free."
    ]
  },
  {
    title: "23. Limitations of Liability",
    body: [
      "TO THE FULLEST EXTENT PERMITTED BY LAW, BLACKDOOR, ITS DIRECTORS, EMPLOYEES, AND AGENTS WILL NOT BE LIABLE FOR INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES, INCLUDING LOST PROFIT, LOST REVENUE, OR LOSS OF DATA.",
      "Our total liability for any claim will be limited to the amount paid by you to us during the three (3) month period before the cause of action arose, unless applicable law requires otherwise."
    ]
  },
  {
    title: "24. Indemnification",
    body: [
      "You agree to defend, indemnify, and hold BlackDoor and its affiliates, officers, agents, partners, and employees harmless from claims, damages, losses, liabilities, and expenses arising from your use of the Services, your contributions, your violation of these Terms, your violation of third-party rights, or harmful acts toward another user."
    ]
  },
  {
    title: "25. User Data",
    body: [
      "We maintain certain data transmitted to the Services to manage performance and operate SnapWidget. Although we may perform routine backups, you are responsible for data you transmit or activity associated with your account."
    ]
  },
  {
    title: "26. Electronic Communications",
    body: [
      "Visiting the Services, sending emails, and completing online forms constitute electronic communications. You consent to receive electronic communications and agree that electronic notices, disclosures, signatures, contracts, and records satisfy legal writing requirements."
    ]
  },
  {
    title: "27. California Users and Residents",
    body: [
      "If a complaint is not satisfactorily resolved, California users may contact the Complaint Assistance Unit of the Division of Consumer Services of the California Department of Consumer Affairs at 1625 North Market Blvd., Suite N 112, Sacramento, California 95834, or by telephone at (800) 952-5210 or (916) 445-1254."
    ]
  },
  {
    title: "28. Miscellaneous",
    body: [
      "These Terms and any policies posted by us constitute the entire agreement between you and BlackDoor regarding the Services.",
      "If any provision is unlawful, void, or unenforceable, that provision will be severed and the remaining provisions will remain valid and enforceable.",
      "No joint venture, partnership, employment, or agency relationship is created by these Terms or your use of the Services."
    ]
  },
  {
    title: "29. Contact Us",
    body: [
      "To resolve a complaint or receive more information about the Services, contact BlackDoor at support@blackdoorapps.com."
    ]
  }
];

function SnapWidgetTermsOfService() {
  return (
    <main className="snap-policy-page">
      <section className="snap-policy-hero">
        <a className="snap-policy-brand" href="/" aria-label="BlackDoor home">
          BlackDoor
        </a>
        <p className="snap-policy-kicker">SnapWidget</p>
        <h1>Terms of Service</h1>
        <p className="snap-policy-updated">Last updated {updatedAt}</p>
        <p className="snap-policy-summary">
          These Terms of Service govern your access to and use of SnapWidget and related BlackDoor services.
        </p>
      </section>

      <section className="snap-policy-content" aria-label="Terms of service content">
        <div className="snap-policy-card snap-policy-intro">
          <h2>Agreement to Our Legal Terms</h2>
          <p>
            By accessing or using SnapWidget, you agree to these Terms. If you do not agree, you must stop using the Services immediately.
          </p>
          <p>
            The Services are intended for users who are at least 18 years old. Persons under 18 are not permitted to use or register for the Services.
          </p>
        </div>

        {sections.map((section) => (
          <article className="snap-policy-card" key={section.title}>
            <h2>{section.title}</h2>
            {section.body.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
            {section.link && (
              <p>
                <a href={section.link.href}>{section.link.label}</a>
              </p>
            )}
          </article>
        ))}
      </section>
    </main>
  );
}

export default SnapWidgetTermsOfService;
